import { handleActions } from 'redux-actions';
import { ReserveHistoryState } from '../constants/model';
import Immutable from 'immutable';

const reserveHistoryReducer = handleActions({
    SET_HISTORYVALUE : (state, { payload })=>{
        return state.setIn( [payload.page, payload.field], payload.value)
    },
    SET_HISTOERYRESULT: (state, { payload })=>{
        return state.set( "result", Immutable.fromJS(payload.value))
    },

}, ReserveHistoryState)

export default reserveHistoryReducer
